import createCachedSelector from 're-reselect';
import {getParkingLotsByBuildingId} from '../../data/parkingLot/selectors';
import {RootState} from '../../rootReducer';
import {getParkingNodeInformation} from './helpers';
import {ParkingNodeOnDateSelectorProps} from '../../util/parkingNodes/types';

export const getAllParkingReservationCountPerNodeOnDate = (state: RootState) =>
  state.data.parkingReservation.parkingCountPerNodeOnDate;

export const getParkingInformationByNodeId = createCachedSelector(
  (state: RootState, props: ParkingNodeOnDateSelectorProps) => getParkingLotsByBuildingId(state, props.buildingId),
  getAllParkingReservationCountPerNodeOnDate,
  (_: RootState, props: ParkingNodeOnDateSelectorProps) => props,
  (parkingLots, parkingCountPerNodeByDate, {nodeId, date}) => {
    const parkingZones = parkingLots.flatMap((parkingLot) => parkingLot.parkingZones);
    return getParkingNodeInformation({
      nodeId,
      date,
      parkingLots,
      parkingZones,
      parkingCountPerNodeByDate,
    });
  },
)((_, {nodeId, date}) => `${nodeId}:${date.toISOString() || ''}`);

export const getAreAllParkingNodesFull = createCachedSelector(
  (state: RootState, date: Date, buildingId: string) => getParkingLotsByBuildingId(state, buildingId),
  getAllParkingReservationCountPerNodeOnDate,
  (_: RootState, date: Date) => date,
  (parkingLots, parkingCountPerNodeByDate, date) => {
    if (!parkingLots.length) return false;
    const parkingZones = parkingLots.flatMap((parkingLot) => parkingLot.parkingZones);

    return parkingLots.every((parkingLot) => {
      if (!parkingLot) {
        return false;
      }

      const {isFull} = getParkingNodeInformation({
        nodeId: parkingLot.id,
        date,
        parkingLots,
        parkingZones,
        parkingCountPerNodeByDate,
      });

      return isFull;
    });
  },
)((_, date, buildingId) => `${date.toISOString() || ''}-${buildingId}`);
